export default "__VITE_ASSET__D8q1WEvS__"